import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import {
  FaMoneyBillWave,
  FaPlus,
  FaEdit,
  FaTrash,
  FaFileExcel,
  FaWallet,
  FaCheckCircle
} from 'react-icons/fa';

function Fees() {

  const [fees, setFees] = useState([]);

  const [studentId, setStudentId] = useState('');
  const [totalFee, setTotalFee] = useState('');
  const [paidFee, setPaidFee] = useState('');
  const [dueDate, setDueDate] = useState('');

  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = () => {

    axios.get(
      `${process.env.REACT_APP_API_URL}/pending-fees`
    )
    .then((res) => {
      setFees(res.data);
    })
    .catch((err) => {
      console.log(err);
    });

  };

  const exportToExcel = () => {

    const worksheet =
      XLSX.utils.json_to_sheet(fees);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Fees'
    );

    const excelBuffer = XLSX.write(
      workbook,
      {
        bookType: 'xlsx',
        type: 'array'
      }
    );

    const data = new Blob(
      [excelBuffer],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    saveAs(data, 'Fees.xlsx');

  };

  const resetForm = () => {

    setEditId(null);
    setStudentId('');
    setTotalFee('');
    setPaidFee('');
    setDueDate('');

  };

  const addFee = () => {

    axios.post(
      `${process.env.REACT_APP_API_URL}/fee`,
      {
        student_id: studentId,
        total_fee: totalFee,
        paid_fee: paidFee,
        due_date: dueDate
      }
    )
    .then(() => {

      alert('Fee Added Successfully');

      resetForm();
      fetchFees();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const editFee = (fee) => {

    setEditId(fee.id);

    setStudentId(
      fee.student_id || ''
    );

    setTotalFee(
      fee.total_fee
    );

    setPaidFee(
      fee.paid_fee
    );

    if (fee.due_date) {

      setDueDate(
        fee.due_date.substring(0, 10)
      );

    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  };

  const updateFee = () => {

    axios.put(
      `${process.env.REACT_APP_API_URL}/fees/${editId}`,
      {
        total_fee: totalFee,
        paid_fee: paidFee,
        due_date: dueDate
      }
    )
    .then(() => {

      alert('Fee Updated Successfully');

      resetForm();
      fetchFees();

    })
    .catch((err) => {
      console.log(err);
    });

  };

  const deleteFee = (id) => {

    if (
      !window.confirm(
        'Delete Fee Record?'
      )
    ) {
      return;
    }

    axios.delete(
      `${process.env.REACT_APP_API_URL}/fees/${id}`
    )
    .then(() => {

      alert('Fee Deleted');

      fetchFees();

    })
    .catch((err) => {
      console.log(err);
    });

  };

const sendFeeReminder = (fee) => {

  axios.post(
    `${process.env.REACT_APP_API_URL}/send-fee-reminder`,
    {
      parent_id: fee.parent_id,
      student_name: fee.student_name,
      pending_fee: fee.pending_fee,
      due_date: fee.due_date
    }
  )
  .then((res) => {

    alert(res.data.message);

  })
  .catch((err) => {

    console.log(err);
    alert('Failed To Send Reminder');

  });

};

  const totalCollection =
    fees.reduce(
      (sum, fee) =>
        sum + Number(fee.paid_fee || 0),
      0
    );

  const totalPending =
    fees.reduce(
      (sum, fee) =>
        sum + Number(fee.pending_fee || 0),
      0
    );

  return (

    <Layout>

      <div className="container-fluid">

        <div className="mb-4">

          <h1
            style={{
              fontWeight: '800',
              color: '#0f172a'
            }}
          >
            Fees Management
          </h1>

          <p
            style={{
              color: '#64748b'
            }}
          >
            School Billing & Fee Collection
          </p>

        </div>

        {/* SUMMARY CARDS */}

        <div className="row mb-4">

          <div className="col-md-6">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                background:
                  'linear-gradient(135deg,#10b981,#22c55e)',
                color: '#fff'
              }}
            >

              <h5>
                Total Collection
              </h5>

              <h2>
                ₹{totalCollection}
              </h2>

            </div>

          </div>

          <div className="col-md-6">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                background:
                  'linear-gradient(135deg,#ef4444,#f87171)',
                color: '#fff'
              }}
            >

              <h5>
                Pending Fees
              </h5>

              <h2>
                ₹{totalPending}
              </h2>

            </div>

          </div>

        </div>

        {/* FORM */}

        <div
          className="card p-4 mb-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <h4 className="mb-4">

            {editId ? (
              <>
                <FaEdit /> Edit Fee
              </>
            ) : (
              <>
                <FaPlus /> Add Fee
              </>
            )}

          </h4>

          <div className="row">

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Student ID"
                value={studentId}
                disabled={
                  editId !== null
                }
                onChange={(e) =>
                  setStudentId(
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Total Fee"
                value={totalFee}
                onChange={(e) =>
                  setTotalFee(
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <input
                className="form-control"
                placeholder="Paid Fee"
                value={paidFee}
                onChange={(e) =>
                  setPaidFee(
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <input
                type="date"
                className="form-control"
                value={dueDate}
                onChange={(e) =>
                  setDueDate(
                    e.target.value
                  )
                }
              />

            </div>

          </div>

          {editId ? (

            <>
              <button
                className="btn btn-warning"
                onClick={updateFee}
              >
                Update Fee
              </button>

              <button
                className="btn btn-secondary ms-2"
                onClick={resetForm}
              >
                Cancel
              </button>
            </>

          ) : (

            <button
              className="btn btn-primary"
              onClick={addFee}
            >
              Add Fee
            </button>

          )}

        </div>

        {/* TABLE */}

        <div
          className="card p-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <div className="d-flex justify-content-between align-items-center mb-4">

            <h4>
              <FaMoneyBillWave /> Fee Records
            </h4>

            <button
              className="btn btn-success"
              onClick={exportToExcel}
            >
              <FaFileExcel /> Export Excel
            </button>

          </div>

          <div className="table-responsive">

            <table className="table">

              <thead>

                <tr
                  style={{
                    background:
                      '#eef2ff'
                  }}
                >

                  <th>ID</th>
                  <th>Student</th>
                  <th>Parent</th>
                  <th>Mobile</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Pending</th>
                  <th>Status</th>
                  <th>Actions</th>

                </tr>

              </thead>

              <tbody>

                {fees.map((fee) => (

                  <tr key={fee.id}>

                    <td>{fee.id}</td>

                    <td>
                      {fee.student_name}
                    </td>

                    <td>
                      {fee.parent_name}
                    </td>

                    <td>
                      {fee.mobile}
                    </td>

                    <td>
                      ₹{fee.total_fee}
                    </td>

                    <td>
                      ₹{fee.paid_fee}
                    </td>

                    <td>
                      ₹{fee.pending_fee}
                    </td>

                    <td>

                      {Number(
                        fee.pending_fee
                      ) === 0 ? (

                        <span
                          className="badge bg-success"
                        >
                          <FaCheckCircle /> Paid
                        </span>

                      ) : (

                        <span
                          className="badge bg-danger"
                        >
                          <FaWallet /> Pending
                        </span>

                      )}

                    </td>

                    <td>

  <button
    className="btn btn-primary btn-sm"
    onClick={() =>
      sendFeeReminder(fee)
    }
  >
    Reminder
  </button>

  <button
    className="btn btn-warning btn-sm ms-2"
    onClick={() =>
      editFee(fee)
    }
  >
    <FaEdit />
  </button>

  <button
    className="btn btn-danger btn-sm ms-2"
    onClick={() =>
      deleteFee(
        fee.id
      )
    }
  >
    <FaTrash />
  </button>

</td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Layout>

  );

}

export default Fees;